import { Select } from '@99designs/common/components/Select';
import { FormattedMessage } from '@99designs/common/i18n';
import { Field } from 'common/components/Form';
import Link from 'launch/components/Link';
import StockImageExample from 'launch/components/StockImageExample';
import React from 'react';
import { intlShape } from 'react-intl';

interface Props {
    categoryKey: string;
    onChange: Function;
    value: string;
}

export default class StockImagesField extends React.Component<Props> {
    static contextTypes = {
        intl: intlShape.isRequired,
    };

    get stockArticleUrl() {
        const { locale } = this.context.intl;
        return `https://support.99designs.com/hc/${locale}/articles/115004164106`;
    }

    render() {
        return (
            <Field
                htmlFor="allowStockImages"
                title={
                    <span>
                        {__('Allow the use of stock images in your contest?')}
                        <StockImageExample categoryKey={this.props.categoryKey} />
                    </span>
                }
                message={
                    <FormattedMessage
                        message={__(
                            'There may be additional costs for designs that use stock images. Designers will include details for stock images, so you can buy stock at the end of your contest. {stock_article_link}'
                        )}
                        values={{
                            stock_article_link: (
                                <Link href={this.stockArticleUrl}>
                                    {__('Learn more about stock')}
                                </Link>
                            ),
                        }}
                    />
                }
            >
                <Select
                    id="allowStockImages"
                    onChange={({ value }) => this.props.onChange(value)}
                    value={this.props.value}
                    options={[
                        { value: '', label: __('Select'), disabled: true },
                        {
                            value: 'yes',
                            label: __('Yes, allow designers to recommend stock images'),
                        },
                        { value: 'no', label: __('No, I will provide my own images') },
                        { value: 'not-sure', label: __("I'm not sure") },
                    ]}
                />
            </Field>
        );
    }
}
